(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("myNotificationsResource", ["$resource", myNotificationsResource]);
    function myNotificationsResource($resource) {
        return $resource("/api/notifications/myNotifications/:id/:action", { action: "@action", id: "@id" }, {
            viewAll: {
                method: "GET",
                params: { action: "viewAll" },
                isArray: true
            },
            viewUnread: {
                method: "GET",
                params: { action: "viewUnread" },
                isArray: true
            },
            markAsRead: {
                method: "POST",
                params: { action: "markAsRead" }
            },
            resend: {
                method: "POST",
                params: { action: "resend" }
            },
            deleteNotifications: {
                method: "POST",
                params: { action: "delete" }
            },
            navBar: {
                method: "GET",
                params: { action: "navBar" }
            }
        });
    }
}());
